@if (mapUrl) {
  <div class="map-box">
    <!-- map -->
    <iframe
      class="map-box__map"
      loading="lazy"
      allowfullscreen=""
      referrerpolicy="no-referrer-when-downgrade"
      [src]="mapUrl"
      (load)="onLoadFinished()"
      [hidden]="isLoadingMap"></iframe>
  </div>
  @if (isLoadingMap) {
    <div>
      <!-- skeleton -->
      <ngx-skeleton-loader
        [count]="1"
        [theme]="{
          'border-radius': '0.6em',
          margin: '0em',
          width: '100%',
          height: '38em',
        }"></ngx-skeleton-loader>
    </div>
  }
}
